import { Platform, StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  cardStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    paddingVertical: 15,
    shadowColor: Colors.blackThree,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    elevation: 4,
  }),
  loadingCardContainer: theme => ({
    marginTop: 5,
    marginHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.cardBackgroundColor,
    overflow: 'hidden',
  }),
  lineBottom: theme => ({
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.borderColorFour,
  }),
  paymentContainer: {
    paddingVertical: 15,
    flexDirection: 'row',
  },
  firstChild: {
    paddingTop: 6,
  },
  paymentItem: {
    flex: 1,
  },
  paymentValues: theme => ({
    fontSize: 16,
    marginTop: 6,
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
  }),
  paymentTags: theme => ({
    fontSize: 16,
    color: theme.colors.textColorTwo,
  }),
  primaryButtonDisableStyle: theme => ({
    backgroundColor: theme.colors.buttons.disabledThree,
  }),

  tagStyle: {
    marginTop: 6,
    alignSelf: 'flex-start',
  },
  redBorder: {
    marginTop: 16,
    padding: 10,
    borderWidth: 1,
    borderColor: Colors.vfRed,
    borderRadius: 6,
  },
  orangeBorder: {
    marginTop: 16,
    padding: 10,
    borderWidth: 1,
    borderColor: Colors.fresh_orange,
    borderRadius: 6,
  },
  imageSize: {
    width: 25,
    height: 25,
    marginTop: 10,
  },
  paymentStatus: {
    marginTop: 6,
  },
  textStyle: theme => ({
    color: theme.colors.cardBackgroundColorThree,
  }),
  paymentSuccessButtonStyle: {
    backgroundColor: Colors.success,
    borderRadius: 20.8,
    paddingHorizontal: 17,
    paddingVertical: 7,
    alignSelf: 'center',
    height: undefined,
    justifyContent: 'center',
    alignItems: 'center',
  },
  paymentSuccessTextStyle: {
    color: Colors.white,
    fontSize: 16.6,
  },
  optionalButtonsStyle: {
    marginTop: 16,
  },
  errorBackgroundStyle: {
    backgroundColor: Colors.transparent,
    height: 224,
  },
  errorIconStyle: {
    marginTop: 46,
    width: 48,
    height: 48,
  },
  errorTextStyle: {
    marginBottom: 31.8,
  },
  errorTryButtonContainerStyle: {
    marginTop: 0,
  },
  titleleftContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 21,
    marginTop: 17,
  },
  title: {
    ...Fonts.type.bold,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    lineHeight: 22.9,
  },
  statusDotStyle: {
    marginTop: 3,
    marginRight: 6,
  },
  buttonLoading: theme => ({
    borderColor: theme.colors.borderColor,
    borderWidth: 1,
    marginTop: 15,
    borderRadius: 6,
    padding: 8
  })
});
